// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"318":"08d700d7","373":"aec150a1","984":"08d700d7"}[chunkId] + ".chunk.css";
};